module.exports = __webpack_public_path__ + "img/Ill_History.eac04f24.svg";